// payFloors -- the pay floors a provider's profile publishes, read the one way
// every reader must: the profile walk, and the share card and Preferences
// summary on the Profile page.
//
// A provider can publish two floors, one per unit ($290/hr for locum work and
// $340K/yr for a permanent role are both honest minimums). compensation.type
// names the live ones: an array, or a legacy bare string, any case. An amount
// whose type the provider dropped stays on the profile (the walk and the
// Profile editor both keep it) and is not a floor: the card and the matcher
// skip it, so nothing may print it. With no type stated, every positive amount
// is a floor, as the matcher reads it. The backend's display readers apply the
// same rule (provider/provider-pay-floors.util.ts).
import { asList } from './Onboarding/providerJourney';

export const payTypes = (profile) => asList(profile?.compensation?.type).map((t) => t.toLowerCase());
export const positive = (v) => (Number(v) > 0 ? Number(v) : null);

// The stored amount for one pay type ('hourly' or 'salary') when it is a
// floor, else null.
export function storedFloor(profile, type, field) {
  const types = payTypes(profile);
  return types.length === 0 || types.includes(type) ? positive(profile?.compensation?.[field]) : null;
}
